import { signal } from "@preact/signals-react";

const dirtySources = new Set<string>();

export const hasUnsavedChanges = signal(false);
export const updateReloadPending = signal(false);

export function setUnsavedChanges(source: string, dirty: boolean) {
    if (dirty) {
        dirtySources.add(source);
    } else {
        dirtySources.delete(source);
    }
    hasUnsavedChanges.value = dirtySources.size > 0;
}

export function clearUnsavedChanges(source: string) {
    dirtySources.delete(source);
    hasUnsavedChanges.value = dirtySources.size > 0;
}

export function requestUpdateReload(reload: () => void = reloadPage) {
    if (hasUnsavedChanges.value) {
        updateReloadPending.value = true;
        return false;
    }

    updateReloadPending.value = false;
    reload();
    return true;
}

export function flushPendingUpdateReload(reload: () => void = reloadPage) {
    if (!updateReloadPending.value || hasUnsavedChanges.value) {
        return false;
    }

    updateReloadPending.value = false;
    reload();
    return true;
}

export function forceUpdateReload(reload: () => void = reloadPage) {
    updateReloadPending.value = false;
    reload();
}

function reloadPage() {
    window.location.reload();
}
